import * as typeSagas from './actionTypesSagas';

export const createOrUpdateAudioAbbreviation = (abbreviation) => ({
  type: typeSagas.CREATE_OR_UPDATE_AUDIO_ABBREVIATION,
  payload: {
    abbreviation,
  },
});
export const createOrUpdateMultipleAudioAbbreviations = (abbreviations) => ({
  type: typeSagas.CREATE_OR_UPDATE_MULTIPLE_AUDIO_ABBREVIATIONS,
  payload: {
    abbreviations,
  },
});
export const createOrUpdateMultipleAudioAbbreviationsFail = () => ({
  type: typeSagas.CREATE_OR_UPDATE_MULTIPLE_AUDIO_ABBREVIATIONS_FAIL,
});

export const deleteAudioAbbreviation = (abbreviation) => ({
  type: typeSagas.DELETE_AUDIO_ABBREVIATION,
  payload: {
    abbreviation,
  },
});
export const getAllAudioAbbreviations = (search, page, skip, limit) => ({
  type: typeSagas.GET_ALL_AUDIO_ABBREVIATIONS,
  payload: {
    search,
    page,
    skip,
    limit,
  },
});
